import React from 'react';
import "./Marketing.css";
import servBnr4 from "../../../assets/imgs/services/servBnr4.jpg";
import mkbnr from "../../../assets/imgs/services/mkbnr.jpg";
import ReadyToBusiness from '../../ReadyToBusiness/ReadyToBusiness';
import { Button } from "@mui/material";
import { Helmet } from "@dr.pogodin/react-helmet";
import PropTypes from "prop-types";

function Marketing({ open, openContactForm }) {
  const handleWhatsApp = () => {
    window.open("https://wa.me/919876543210", "_blank");
  };

  return (
    <div className='serpMn'>
       <Helmet>
              <title>Marketing & Strategy |  PAYTECH ADVISOR</title>
            </Helmet>
      <div className="mkBnr">
        <div className="maxW">
          <div className="mkBnrLft">
            <div className='mkblfCon'>
              <h1>Marketing & Strategy</h1>
              <p>Your Brand, Everywhere That Matters.</p>
              <div className='serDtBTns'>
                <Button variant="contained" onClick={openContactForm}>
                  Enquire Now
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="mkBnrRyt">
          <img src={servBnr4} alt="servBnr4" />
        </div>
      </div>

      <div className='hdPaWrp'>
        <div className="maxW">
          <h3>At Marketing Advisors, we do more than campaigns</h3>
          <p>
            At Paytech Advisors, we deliver marketing strategies that connect your brand with the right audience, at the right time, across every touchpoint. Our 360° approach integrates digital, social, offline, and experiential marketing to create a cohesive, impactful brand presence.
          </p>
          <p>
            From crafting compelling campaigns and managing performance-driven digital ads to executing on-ground activations, we ensure every marketing effort is aligned with your business objectives. We don’t just promote your brand — we position it for long-term recognition and growth.
          </p>
        </div>
      </div>

      <div className="mkmthd">
        <div className="maxW">
          <h2> Our expertise within 360° Marketing also includes</h2>
          <div className="mkmthMn">
            <div className='mths mthC1'>
              <h4>Rewards & Recognition (R&R) Campaigns</h4>
              <p>Inspiring programs that build loyalty and
strengthen relationships with employees, partners, and customers.</p>
            </div>

            <div className='mths mthC2'>
              <h4>Go-to-Market Strategies</h4>
              <p>Turning ideas into commercial success with clear, insight-driven
roadmaps.</p>
            </div>

            <div className='mths mthC3'>
              <h4>Content Marketing</h4>
              <p>Create impactful content strategies — blogs, videos, and campaigns — that engage and convert customers.</p>
            </div>

            <div className='mths mthC4'>
              <h4>Analytics & Growth</h4>
              <p>Harness data insights to optimize campaigns, measure performance, and drive consistent business growth.</p>
            </div>
          </div>
        </div>
      </div>
      <div className='stga'>
        <div className="maxW">
          <h2>Promotional Expertise Through Our Strategic Alliances</h2>
          <div className="stgaMn">
 <h3>Sales & Trade Promotions - Boosting Sales. Building Loyalty.</h3>
 <ul>
  <li>Festive Campaigns</li>
  <li>Trade Promotions</li>
  <li>Instant Gratification Programs</li>
 </ul>
  <h3>Consumer Promotions - Engage. Excite. Expand.</h3>
 <ul>
  <li>New Customer Acquisition</li>
  <li>Product Launches & Sampling</li>
  <li>Instant Gratification Programs</li>
 </ul>
  <h3>Alliances & Partnerships- Collaboration that Creates Impact.</h3>
 <ul>
  <li>Cross-Promotions</li>
  <li>Joint Marketing Initiatives</li>
  <li>Movie & Entertainment Tie-ups</li>
  <li>Exclusive Discounts for Existing Customers</li>
  <li>Celebrity endorsements </li>
 </ul>
          </div>
        </div>
      </div>
      <div className='mkBnrWrp'>
        <div className="maxW">
          <img src={mkbnr} alt="mkbnr-img" />
          <p>
            With Paytech Advisors, your marketing isn’t a collection of isolated activities — it’s a unified strategy built to maximize reach, influence, and return on investment.
          </p>
        </div>
      </div>

      <div>
        <ReadyToBusiness />
      </div>
    </div>
  );
}
Marketing.propTypes = {
  open: PropTypes.bool,
  openContactForm: PropTypes.bool,
};

Marketing.defaultProps = {
  open: false,
  openContactForm: false,
};

export default Marketing;
